// extracted by mini-css-extract-plugin
export default {"clients":"Partners_clients__VsuxT","title":"Partners_title__pyNSK","list":"Partners_list__P2COk","logo":"Partners_logo__tG1Cb"};